<template>
  <modal-closable
    :title="title"
    @close="close"
    isMedium="true"
    :isOpen="!!isOpen"
    :key="isOpen"
  >
    <div class="template-selector">
      <div class="template-carousel buttons has-addons">
        <div
          class="template-carusel-item button"
          v-for="(template, id) in templates"
          :key="id"
          @click="selectedTemplateId = id"
          :class="{ 'is-primary': id === selectedTemplateId }"
        >
          <div class="template-name">{{ $t(id) }}</div>
          <div class="template-preview image is-16by9">
            <screen-layout
              :template="template"
              :meals="sampleMeals(template)"
            />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button class="button" @click="close">{{ $t("Cancel") }}</button>
      <button v-focus="isOpen" class="button is-primary" @click="confirm">
        {{ confirmText }}
      </button>
    </div>
  </modal-closable>
</template>

<script>
import { state } from "@/store"
import { ModalClosable } from "@/components/modal"
import ScreenLayout from "@/components/screen/screen-layout"

export default {
  name: "modal-template-selector",
  props: ["title", "confirmText", "templateId", "isOpen", "meals"],
  components: { ModalClosable, ScreenLayout },
  data() {
    return {
      selectedTemplateId: this.templateId
    }
  },
  watch: {
    isOpen() {
      this.selectedTemplateId = this.templateId
    }
  },
  computed: {
    templates() {
      return state.templates
    },
    selectedTemplate() {
      return this.templates[this.selectedTemplateId]
    }
  },
  methods: {
    close() {
      this.$emit("close")
      this.$emit("update:isOpen", false)
    },
    confirm() {
      this.$emit("confirm", this.selectedTemplateId)
      this.$emit("update:isOpen", false)
    },
    sampleMeals(template) {
      return template
        ? template.slicer(this.meals, 1, template.maxMeals)[0]
        : []
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";
.template-carousel {
  flex-wrap: nowrap;
  overflow: auto;
  width: 100%;
  .template-carusel-item {
    display: block;
    position: relative;
    min-width: 80%;
    height: auto;
    @media screen and (max-width: $desktop) and (max-height: $tablet - 1px) {
      min-width: 10rem;
    }
    .template-name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .template-preview {
      text-align: initial;
      .badges {
        white-space: initial;
        .icon {
          margin: initial;
        }
      }
      .price {
        color: initial;
      }
    }
  }
}
</style>
